import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {sancionStore} from "@/store/sancionStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class SancionService{
    private static instance: SancionService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    sancionStore = sancionStore();
    globalStore = globalStore();

    public async index(data: any) {
        this.sancionStore.loading = true;
        await http.get("getIngresos", {params: data}).subscribe({
            next: (response) => {
                this.sancionStore.sanciones = response.data.data;
                this.makePagination(response.data);
                this.sancionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }
    public async indexPasivos(data: any) {
        this.sancionStore.loading = true;
        await http.get("getSancionesPasivos", {params: data}).subscribe({
            next: (response) => {
                this.sancionStore.pasivos = response.data.data;
                this.makePagination(response.data);
                this.sancionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }

    public async getCiente(data: any) {
        this.sancionStore.loading = true;
        await http.get("find_by_matricula", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.sancionStore.cliente = response.data.cliente;
                } else
                    Alert.info(response.data.message)

                this.sancionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }

    public async getCientePasivo(data: any) {
        this.sancionStore.loading = true;
        await http.get("getPasivoDeuda", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.sancionStore.clientePasivo = response.data.clientePasivo;
                } else
                    Alert.info(response.data.message)

                this.sancionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }
    public async getCienteEstado(data: any) {
        this.sancionStore.loading = true;
        await http.get("getClienteEstado", {params: data}).subscribe({
            next: (response) => {
                if (response.data.success) {
                    this.sancionStore.estado = response.data.estado;
                } else
                    Alert.info(response.data.message)

                this.sancionStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }

    public async getEstados() {
        this.sancionStore.loading = true;
        await http.get("getEstados").subscribe({
            next: (response) => {
                    this.sancionStore.estados = response.data;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.sancionStore.loading = false;
            }
        })
    }

    makePagination(page: any) {
        this.sancionStore.pagination.per_page = page.per_page;
        this.sancionStore.pagination.current_page = page.current_page;
        this.sancionStore.pagination.last_page = page.last_page;
    }

    public async getSancion(cobranzaId: number) {
        const data = {cobranzaId: cobranzaId}
        await http.get("showSancion", {params: data}).subscribe({
            next: (response: AxiosResponse) => {
                this.sancionStore.sancion = response.data;
            }
        })
    }

    public async saveSancion(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("saveSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Sancion registrado correctamente");
                        this.sancionStore.sancionNueva = response.data.sancion
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async saveSancionPasivo(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("saveSancionPasivo", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Sancion registrado correctamente");
                        this.sancionStore.sancionNueva = response.data.sancion
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async cambiarEstado(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("cambiarEstado", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Cambio de estado realizado exitosamente");
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async updateSancion(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("updateSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Sancion registrado correctamente");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async generarPlanPagos(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("generarPlanPagosSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        Alert.successTotastr("Plan de pagos generado correctamente");
                        this.sancionStore.loading = false;
                        this.sancionStore.cuotas = response.data.cuotas;
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }

                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }
    public async showPlaPagoSancion(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("showPlaPagoSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.sancionStore.cuotas = response.data.cuotas;
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }

                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async historial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("historial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.historial = response.data.historial
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

     public async anularPlanPagos(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("anularPlanPagosSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        Alert.successTotastr("Plan de pagos eliminado correctamente");
                        this.sancionStore.loading = false;
                        this.sancionStore.cuotas = [];
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async showCuota(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("showPlaPagoSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    this.sancionStore.cuotas = response.data.cuotas;
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async baja(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sancionStore.loading = true;
            http.post("bajaSancion", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.sancionStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Sancion eliminada correctamente");
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.sancionStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async imprimirOrden(id:number) {
        await http.get(`imprimirOrdenVenta/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                window.open(
                    `${this.baseURL}imprimirOrdenVenta/${id}`, "_blank");
            },
        })
    }
    public async imprimirPlan(id:number) {
        await http.get(`imprimirPlanPagoSancion/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                window.open(
                    `${this.baseURL}imprimirPlanPagoSancion/${id}`, "_blank");
            },
        })
    }
}